// extracted by mini-css-extract-plugin
export default {"questions":"DynamicInput_questions__UmGbQ","or-connector":"DynamicInput_or-connector__Td+sE","or-text":"DynamicInput_or-text__MjUmB"};